export function errMsg(error, fallback) {
  const fieldErrors = error?.data?.details?.fieldErrors;
  const firstFieldMsg = fieldErrors && Object.values(fieldErrors).flat()[0];
  return firstFieldMsg ?? error?.data?.error ?? fallback;
}
